// API Configuration
// In production, try to detect the API URL from the current origin
// If VITE_API_URL is not set, try to infer from window.location
const getDefaultAPIURL = () => {
  // If VITE_API_URL is explicitly set, use it (must include protocol)
  if (import.meta.env.VITE_API_URL) {
    const url = import.meta.env.VITE_API_URL.trim();
    // Ensure it has a protocol
    if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
      // If missing protocol, assume https in production, http in development
      const protocol = import.meta.env.PROD ? 'https://' : 'http://';
      return protocol + url;
    }
    return url;
  }

  // Vite dev: same-origin so requests go through the /api proxy (avoids
  // cross-origin blocks / empty profile pages when :8000 is filtered).
  if (import.meta.env.DEV) {
    return '';
  }
  
  // In production build, try to use same origin as fallback
  if (import.meta.env.PROD && typeof window !== 'undefined') {
    // In production, if no API URL is set, try to use the same origin
    // This assumes backend is on the same domain or a subdomain
    const origin = window.location.origin;
    // Ensure origin has protocol (it should, but be safe)
    if (origin && (origin.startsWith('http://') || origin.startsWith('https://'))) {
      return origin;
    }
    // If origin is missing protocol, add https://
    if (origin) {
      return 'https://' + origin;
    }
  }
  
  return 'http://localhost:8000'; // Development default
};

export const API_URL = getDefaultAPIURL();

// Detect if we're in production
export const IS_PRODUCTION = import.meta.env.PROD || (typeof window !== 'undefined' && !window.location.hostname.includes('localhost'));

// Debug: Log API URL configuration
if (typeof window !== 'undefined') {
  console.log('[DEBUG] API Configuration:', {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    API_URL: API_URL || '(same-origin / Vite proxy)',
    envMode: import.meta.env.MODE,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    IS_PRODUCTION: IS_PRODUCTION,
    windowOrigin: window.location.origin
  });
  
  // Warn if API_URL is invalid (empty string is valid in Vite DEV — same-origin proxy)
  if (API_URL !== '' && (!API_URL || (!API_URL.startsWith('http://') && !API_URL.startsWith('https://')))) {
    console.error('[ERROR] Invalid API_URL configuration!');
    console.error('API_URL must be a full URL with protocol (http:// or https://)');
    console.error('Current API_URL:', API_URL);
    console.error('Please set VITE_API_URL environment variable during build.');
  } else if (IS_PRODUCTION && API_URL.includes('localhost')) {
    console.error('[ERROR] API_URL is set to localhost in production!');
    console.error('Please set VITE_API_URL environment variable during build.');
    console.error('Current API_URL:', API_URL);
  }
}

// Firebase Configuration
export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Character sets
export const LETTERS = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)); // A-Z
export const NUMBERS = Array.from({ length: 10 }, (_, i) => String(i)); // 0-9




